import {
	Component,
	OnInit,
	ViewEncapsulation,
	trigger,
	state,
	style,
	transition,
	animate
} from '@angular/core';

import { SpeakerService } from '../speaker.service';
import {Summary} from '@angular/compiler';


@Component({
	selector: 'summary',
	templateUrl: './summary.component.html',
	styleUrls: ['./summary.component.css'],
	encapsulation: ViewEncapsulation.None,
	animations: [
		trigger('toggleDetails', [
			state('void', style({
				'max-height': '0px'
			})),
			state('*', style({
				'max-height': '20000px'
			})),
			transition(':enter, :leave', animate('600ms ease-in-out'))
		])
	]
})
export class SummaryComponent implements OnInit {
	
	speakers: any;
	constructor(private speakerSrv: SpeakerService) {
		this.speakerSrv.speakersChange.subscribe(speakers => {
			this.speakers = speakers;
			this.updateStats();
		});
	}
	
	SummaryStatement: any;
	details: boolean = false;
	summaryDetailsStatement: any[];
	
	rowLabels: string[] = [
		'Change over time', 'Gender', 'Age', 'Class', 'Region', 'Change over time: Gender', 'Change over time: Age', 'Gender: Age', 'Change over time: Class', 'Gender: Class', 'Age: Class', 'Change over time: Region', 'Gender: Region', 'Age: Region', 'Class: Region', 'Change over time: Gender: Age', 'Change over time: Gender: Class', 'Change over time: Age: Class', 'Gender: Age: Class', 'Change over time: Gender: Region', 'Change over time: Age: Region', 'Gender: Age: Region', 'Change over time: Class: Region', 'Gender: Class: Region', 'Age: Class: Region', 'Change over time: Gender: Age: Class', 'Change over time: Gender: Age: Region', 'Change over time: Gender: Class: Region', 'Change over time: Age: Class: Region', 'Gender: Age: Class: Region', 'Change over time: Gender: Age: Class: Region','Residuals'
	];
	
	ngOnInit(): void {
	}
	
	updateStats() {
		let self = this;
		let clonedSpeakerArr = this.speakers.map((speaker) => {
			return Object.assign({}, speaker);
		});
		
		clonedSpeakerArr.sort((one, two) => {
			return one["name_new"].localeCompare(two["name_new"]);
		});
		let freqs = [];
		for (let i = 0; i < clonedSpeakerArr.length; i++) {
			freqs.push(clonedSpeakerArr[i]['relative_freq']);
		}
		self.speakerSrv.doTest(freqs).subscribe((res) => {
			let response = JSON.parse(res['_body']);
			if (Object.keys(response).length > 0) {
				this.SummaryStatement = this.getSummaryStatement(response);
				this.summaryDetailsStatement = this.getDetails(response[0]);
			}
		});
	}
	
	showDetails() {
		this.details = !this.details;
	}
	
	getDetails(response: any) {
		let table = [];
		for (let rowidx = 0; rowidx < this.rowLabels.length; rowidx++) {
			let row = [this.rowLabels[rowidx]];
			for (let colidx = 0; colidx < response.length; colidx++) {
				row.push(response[colidx][rowidx]);
			}
			table.push(row);
		}
		return table;
	}
	
	isNumber(val: any): boolean {
		return typeof val == 'number';
	}
	
	getSummaryStatement(response: any) {
		let intro = "The analysis was performed using the 1994 and 2014 corpora, which consist of almost " +
			(this.speakerSrv.state['words'] / 1000000).toFixed(0) + " million running words of transcribed British speech from 500 speakers across the UK." +
			" It focused on the sociolinguistic variation in the use of '" + this.speakerSrv.term + "'.<br /><br /><br />";
		let interactions = response[0][4];
		let found = false;
		for (let i = 0; i < interactions.length; i++) {
			if (interactions[i] < 0.05) {
				found = true;
				break;
			}
		}
		if (found) {
			let interacStr = "Statistical analysis revealed the effect of the following variable(s):<br /><br />";
			if (interactions[0] < 0.05)
				interacStr += "• Change over time<br />";
			if (interactions[1] < 0.05)
				interacStr += "• Gender<br />";
			if (interactions[2] < 0.05)
				interacStr += "• Age<br />";
			if (interactions[3] < 0.05)
				interacStr += "• Class<br />";
			if (interactions[4] < 0.05)
				interacStr += "• Region<br />";
			if (interactions[5] < 0.05)
				interacStr += "• Combination of Change over time and Gender<br />";
			if (interactions[6] < 0.05)
				interacStr += "• Combination of Change over time and Age<br />";
			if (interactions[7] < 0.05)
				interacStr += "• Combination of Gender and Age<br />";
			if (interactions[8] < 0.05)
				interacStr += "• Combination of Change over time and Class<br />";
			if (interactions[9] < 0.05)
				interacStr += "• Combination of Gender and Class<br />";
			if (interactions[10] < 0.05)
				interacStr += "• Combination of Age and Class<br />";
			if (interactions[11] < 0.05)
				interacStr += "• Combination of Change over time and Region<br />";
			if (interactions[12] < 0.05)
				interacStr += "• Combination of Gender and Region<br />";
			if (interactions[13] < 0.05)
				interacStr += "• Combination of Age and Region<br />";
			if (interactions[14] < 0.05)
				interacStr += "• Combination of Class and Region<br />";
			if (interactions[15] < 0.05)
				interacStr += "• Combination of Change over time, Gender and Age<br />";
			if (interactions[16] < 0.05)
				interacStr += "• Combination of Change over time, Gender and Class<br />";
			if (interactions[17] < 0.05)
				interacStr += "• Combination of Change over time, Age and Class<br />";
			if (interactions[18] < 0.05)
				interacStr += "• Combination of Gender, Age and Class<br />";
			if (interactions[19] < 0.05)
				interacStr += "• Combination of Change over time, Gender and Region<br />";
			if (interactions[20] < 0.05)
				interacStr += "• Combination of Change over time, Age and Region<br />";
			if (interactions[21] < 0.05)
				interacStr += "• Combination of Gender, Age and Region<br />";
			if (interactions[22] < 0.05)
				interacStr += "• Combination of Change over time, Class and Region<br />";
			if (interactions[23] < 0.05)
				interacStr += "• Combination of Gender, Class and Region<br />";
			if (interactions[24] < 0.05)
				interacStr += "• Combination of Age, Class and Region<br />";
			if (interactions[25] < 0.05)
				interacStr += "• Combination of Change over time, Gender, Age and Class<br />";
			if (interactions[26] < 0.05)
				interacStr += "• Combination of Change over time, Gender, Age and Region<br />";
			if (interactions[27] < 0.05)
				interacStr += "• Combination of Change over time, Gender, Class and Region<br />";
			if (interactions[28] < 0.05)
				interacStr += "• Combination of Change over time, Age, Class and Region<br />";
			if (interactions[29] < 0.05)
				interacStr += "• Combination of Gender, Age, Class and Region<br />";
			
			return intro + interacStr;
		} else {
			return intro + "Statistical analysis didn't reveal any significant effect.";
		}
	}
}


// WEBPACK FOOTER //
// /home/ingvars/BNC-Lab/front/src/app/summary/summary.component.ts